import { ADD_CODE } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_CODE.LOAD:
      return {
        ...state,
        loading: true
      };
    case ADD_CODE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case ADD_CODE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
